import { useState } from 'react'
import {
    SquaresFourIcon,
    SelectionBackgroundIcon,
    SelectionForegroundIcon,
} from '@phosphor-icons/react'
import { useDispatch } from 'react-redux'
import { bringToFront, sendToBack } from '../../../../store/actions'
import { ScoopMenuItem, ScoopMenuItemWithSubmenu, ScoopTooltip, ScoopButton } from '../../../ui'
import styles from './ReorderPicker.module.scss'

export const ReorderPicker = ({ origin, objectId, title, closeMenu, tooltip }) => {
    const dispatch = useDispatch()
    const [anchorEl, setAnchorEl] = useState(null)

    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handlePopoverClose = () => {
        setAnchorEl(null)
    }

    const getPopoverPosition = () => {
        if (origin === 'top') {
            return styles.popoverTop
        } else if (origin === 'right') {
            return styles.popoverRight
        } else {
            return styles.popoverBottom
        }
    }

    const handleReorder = (order) => {
        if (order === 'front') {
            dispatch(bringToFront(objectId))
        } else {
            dispatch(sendToBack(objectId))
        }
        handlePopoverClose()
        closeMenu && closeMenu()
    }

    const open = Boolean(anchorEl)

    const SubmenuContent = () => {
        return (
            <>
                <ScoopMenuItem
                    leftSection={<SelectionBackgroundIcon size={18} weight="regular" />}
                    primary="Bring to front"
                    onClick={() => handleReorder('front')}
                />
                <ScoopMenuItem
                    leftSection={<SelectionForegroundIcon size={18} weight="regular" />}
                    primary="Send to back"
                    onClick={() => handleReorder('back')}
                />
            </>
        )
    }

    return (
        <>
            {title ? (
                <ScoopMenuItemWithSubmenu
                    leftSection={<SquaresFourIcon size={18} weight="regular" />}
                    primary={title}
                    submenu={<SubmenuContent />}
                    placement="right-start"
                    offset={8}
                />
            ) : (
                <>
                    <ScoopTooltip title={'Reorder'} disableHoverListener={!tooltip}>
                        <ScoopButton variant="text" onClick={handlePopoverOpen}>
                            <SquaresFourIcon size={20} weight="regular" className={styles.icon} />
                        </ScoopButton>
                    </ScoopTooltip>
                    {open && (
                        <>
                            <div className={styles.backdrop} onClick={handlePopoverClose} />
                            <div className={`${styles.popover} ${getPopoverPosition()}`}>
                                <div className={styles.popoverContent}>
                                    <SubmenuContent />
                                </div>
                            </div>
                        </>
                    )}
                </>
            )}
        </>
    )
}
